import { render, staticRenderFns } from "./choiceStudent.vue?vue&type=template&id=58cf4d08&scoped=true&"
import script from "./choiceStudent.vue?vue&type=script&lang=js&"
export * from "./choiceStudent.vue?vue&type=script&lang=js&"
import style0 from "./choiceStudent.vue?vue&type=style&index=0&id=58cf4d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf4d08",
  null
  
)

export default component.exports